import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'
import { DaydicPDF } from '../../models/main/pdf'

@Component({
  selector: 'ddc-pdf-button',
  templateUrl: './ddc-pdf-button.component.html',
  styleUrls: ['./ddc-pdf-button.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcPdfButtonComponent {
  @Input() pdf: DaydicPDF
  @Input() _icon: string
  @Input() _color: string

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  constructor(public themeService: ThemeService) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }

  downloadPDF(): void {
    // download pdf.pdf_url
    if (this.pdf && this.pdf.pdf_url) {
      window.open(this.pdf.pdf_url, '_blank')
    }
  }
}
